module.exports = __webpack_public_path__ + "68fa8942d6b5b7f370770c2b059d949c.jpg";